/** Public Cloud Function endpoint for designerInvoiceAgentApi. */
export const DESIGNER_INVOICE_AGENT_ENDPOINT =
  'https://us-central1-lctf-projects.cloudfunctions.net/designerInvoiceAgentApi';
